import { api } from '../services/rest';
//import { LOGIN, LOGOUT } from '../actions/types';
import { session as currentSession } from './session';

const login = (username, password) => {
    return api
        .post('/Authenticate/Login',{ username: username, password: password })
        .then(response => {
            if (response) {
                currentSession.register(response.data);
                console.info({ message: 'A user has logged in', details: response.data })
            }
        })
}

const logout =() => {
    return api
        .post('/Authenticate/Logout')
        .then(_ => {
            let user = session.getUser();
            currentSession.clear();
            console.info({ message: 'A user has logged out', details: user });
        });
}

export const authentication = { login, logout }

export const session = currentSession;
